/**
 * Shopper enums - numeric values mirror the future Marketplace.API contract
 * (HLD §13 `ShopperAccount`, `SavedSearch`).
 */

/** How saved-search and watchlist alerts are delivered (HLD ACC-04). */
export enum AlertChannel {
  Email = 1,
  Text = 2,
  EmailAndText = 3
}

export const AlertChannelLabel: Record<AlertChannel, string> = {
  [AlertChannel.Email]: 'Email',
  [AlertChannel.Text]: 'Text',
  [AlertChannel.EmailAndText]: 'Text + email'
};

/**
 * Per-topic notification opt-ins (HLD ACC-04). Persisted on `ShopperState` as
 * plain strings so the wire contract stays a simple string array.
 */
export const NOTIFICATION_TOPICS = ['outbid', 'ending-soon', 'order-updates', 'hunt-matches'] as const;

export type NotificationTopic = (typeof NOTIFICATION_TOPICS)[number];

export const NotificationTopicLabel: Record<NotificationTopic, string> = {
  outbid: 'Outbid alerts',
  'ending-soon': 'Auction ending soon',
  'order-updates': 'Order updates',
  'hunt-matches': 'Hunt matches'
};
